import { render, staticRenderFns } from "./_uid.vue?vue&type=template&id=2bf5c4fe&scoped=true&"
import script from "./_uid.vue?vue&type=script&lang=js&"
export * from "./_uid.vue?vue&type=script&lang=js&"
import style0 from "./_uid.vue?vue&type=style&index=0&id=2bf5c4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5c4fe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Animation: require('/vercel/path0/components/Animation.vue').default,Media: require('/vercel/path0/components/Media.vue').default,Modules: require('/vercel/path0/components/Modules.vue').default,Footer: require('/vercel/path0/components/Footer.vue').default})
